var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('div',{staticClass:"centered"},[_c('router-link',{attrs:{"to":{name:'templates'}}},[_vm._v("‹ Back")]),_vm._v(" "),_c('h1',[_vm._v("Create a new template")]),_vm._v(" "),_c('div',{staticClass:"raised-box p-box s-above"},[_c('SimpleForm',{attrs:{"onSubmit":_vm.onSubmit,"fields":[
						{
							label : 'Template name',
							name : 'name',
							autocomplete : 'template-name',
							autofocus : true,
							required : true,
							// label_help : 'Accepts alphanumeric characters and underscores.',
						},
						{
							label : 'Organisation',
							name : 'org_id',
							type : 'org',
							required : true,
						},
						{
							label : 'Template',
							name : 'templateData',
							type : 'template',
							autofocus : true,
							required : true,
							// label_help : 'Accepts alphanumeric characters and underscores.',
						} ],"submitText":"Create Template"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }